import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Data, NavigationEnd, NavigationStart, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { IonicModule, ModalController  } from '@ionic/angular';
import { addIcons } from 'ionicons';
import {
  logOutOutline,
  logOutSharp,
  personOutline,
  personSharp,
  folderOpenOutline,
  folderOpenSharp,
  pricetagOutline,
  pricetagSharp,
  cashOutline,
  cashSharp,
  speedometerOutline,
  speedometerSharp,
  helpCircleOutline,
  helpCircleSharp,
  constructOutline,
  constructSharp,
  mailOutline,
  mailSharp,
  paperPlaneOutline,
  paperPlaneSharp,
  heartOutline,
  heartSharp,
  archiveOutline,
  archiveSharp,
  trashOutline,
  trashSharp,
  warningOutline,
  warningSharp,
  bookmarkOutline,
  bookmarkSharp,
  saveOutline,
  saveSharp,
  notificationsOutline,
  notificationsSharp,
  checkmarkCircle,
  close,
  informationCircle,
  closeCircle,
  warning,
} from 'ionicons/icons';
import { UserInfoService } from './services/user-info.service';
import { MenuItem, UserInfoViewModel, UserProfileViewModel } from './models/viewmodels';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { Brand } from './models/dbmodels';
import { filter, Observable, startWith, Subject, switchMap, takeUntil } from 'rxjs';
import { BrandService, loadBrands, selectAllBrands } from './state';
import { ModalAlertProp, ModalConfirmationProps, NotificationTypeEnum, ToastOptions } from './models/config-view-models';
import { NotificationService } from './services/notification.service';
import { IdleService } from './services/idle.service';
import { Title } from '@angular/platform-browser';
import { HeartbeatService } from './services/heartbeat.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    CommonModule,
    IonicModule,
    HttpClientModule,
    RouterOutlet,
  ],
  //providers: [HttpClientModule]
  providers: [NotificationService],
})
export class AppComponent implements OnInit {
  public companyLogoImagePath: string = '';
  applicationLogoImagePath: string = 'assets/images/QuotifyLogoImage.png';
  isCustomerEngineer: boolean = false;
  isEngineerWebsite: boolean = false;
  appPages: any[] = [];
  accountPages: any[] = [];
  helpPages: any[] = [];
  public userProfile: UserProfileViewModel = {};
  public userBrand: Brand = {};
  brandClass: String = environment.defaultBrandClass;
  brands$: Observable<Brand[]> = this.store.select(selectAllBrands);
  //Idle Service Subscriptions
  //warningVisible$ = this.idleService.warningVisible$;
  countdown$ = this.idleService.countdown$;
  private isDismissingModalsForNavigation = false;

  constructor(
    private userInfoService: UserInfoService,
    private notificationService: NotificationService,
    private modalController: ModalController,
    private store: Store,
    private idleService: IdleService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private heartbeatService: HeartbeatService,
  ) {
    addIcons({
      checkmarkCircle,
      informationCircle,
      closeCircle,
      warning,
      close,
      logOutOutline,
      logOutSharp,
      personOutline,
      personSharp,
      folderOpenOutline,
      folderOpenSharp,
      pricetagOutline,
      pricetagSharp,
      cashOutline,
      cashSharp,
      speedometerOutline,
      speedometerSharp,
      helpCircleOutline,
      helpCircleSharp,
      constructOutline,
      constructSharp,
      mailOutline,
      mailSharp,
      paperPlaneOutline,
      paperPlaneSharp,
      heartOutline,
      heartSharp,
      archiveOutline,
      archiveSharp,
      trashOutline,
      trashSharp,
      warningOutline,
      warningSharp,
      bookmarkOutline,
      bookmarkSharp,
      saveOutline,
      saveSharp,
      notificationsOutline,
      notificationsSharp,
    });
    this.userProfile = this.userInfoService.getUserInfo();
    //console.log('app.component', 'constructor', this.userProfile);
    this.isCustomerEngineer = this.userInfoService.isEngineer();

    try {
      let urlStr = window.location.href;

      //set logo image based on the user role
      if (
        this.isCustomerEngineer ||
        urlStr.includes('localhost:8123') ||
        urlStr.includes('specifymanagerpro.com')
      ) {
        this.applicationLogoImagePath = 'assets/images/SpecifyManagerLogo.png';
      } else {
        this.applicationLogoImagePath = 'assets/images/QuotifyLogoImage.png';
      }

      //set page title based on URL
      if (
        urlStr.includes('specifymanagerpro.com') ||
        urlStr.includes('localhost:8123')
      ) {
        // console.log('AppComponent: setting page title for Engineer');
        this.isEngineerWebsite = true;
        this.titleService.setTitle('Quote-ify - Engineer');
      } else {
        this.isEngineerWebsite = false;
        this.titleService.setTitle('Quote-ify');
      }
    } catch (error) {
      console.error('AppComponent: error setting page title', error);
      this.titleService.setTitle('Quote-ify');
      this.applicationLogoImagePath = 'assets/images/QuotifyLogoImage.png';
    }
  }

  async ngOnInit() {
    //looad and set Brands state
    this.store.dispatch(loadBrands());
    this.userInfoService.getUserInfo$().subscribe((userInfo) => {
      if (!!userInfo) {
        this.brands$.subscribe(
          (value) =>
            (this.brandClass = value.find(
              (x) =>
                x.BrandId == userInfo.AppUser?.DefaultCompany.DefaultBrandId,
            )?.CssClass),
        );
      } else {
        this.userBrand = {};
      }

      if (!!userInfo?.AppUser?.UserId) {
        this.heartbeatService.start(userInfo.AppUser.UserId);
      }
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const routeData = this.getDeepestRouteData();
        const excludeIdle = !!routeData?.['excludeIdle'];

        if (excludeIdle) {
          //console.log('AppComponent: route excludes idle -> calling idleService.stop()');
          this.idleService.stop();
        } else {
          //console.log('AppComponent: route is not excluded -> calling idleService.watch()');
          this.idleService.watch();
        }
      });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        // Global safety: force-close open Ionic modals before route changes.
        // This prevents orphaned, unusable overlays when a page navigates away.
        void this.dismissAllOpenModalsForNavigation();
      });
    
    await this.userInfoService.getLogoImageUrlAsync().then((imageUrl: any) => {
      this.companyLogoImagePath = imageUrl;
    });

    //let brandName = this.userInfoService.getBrandName();

    //if(!!userInfo.UserId){
    //  this.brands$.subscribe((value)=> this.userBrand = value.find(x => x.BrandId ==userInfo.DefaultCompany.DefaultBrandId))
    //}
    // if(!!userInfo){
    //   debugger;
    //   var x = this.brandService.getBrandById(userInfo.DefaultCompany.DefaultBrandId);
    //   this.userBrand = allBrands.find(x => x.BrandId == userInfo.DefaultCompany.DefaultBrandId);
    // }
    // var m = this.userBrand;

  }

  getAppPages(){
    //moved to constructor - this.isCustomerEngineer = this.userInfoService.isEngineer();//.hasCustomerRole(CompanyRoleEnum.Engineer);
     var  appPages = [
    { title: 'Notifications', url: '/topmenu/notifications', icon: 'notifications', visible: true },
    { title: 'Projects', url: '/topmenu/project', icon: 'folder-open', visible: true },
    { title: 'Quotes', url: '/topmenu/quotes', icon: 'pricetag', visible: !this.isCustomerEngineer },
    { title: 'Orders', url: '/topmenu/orders', icon: 'cash', visible:  !this.isCustomerEngineer},
    { title: 'Reports', url: '/topmenu/reports', icon: 'speedometer', visible: !this.isCustomerEngineer },
    //{ title: 'Account', url: '/topmenu/account', icon: 'person'},
    { title: 'Help', url: '/topmenu/help', icon: 'help-circle', visible: true },
    { title: 'Admin', url: '/topmenu/admin', icon: 'construct', visible: true },
    //{ title: 'Upload CSVs', url: '/topmenu/admin/admin-excel/upload', icon: 'save'},
    //{ title: 'Manage', url: '/topmenu/manage', icon: 'save'},
    { title: 'Logout', url: '/user/user-logout', icon: 'log-out', visible: true }
  ];
  return appPages;
  }
  ngAfterViewInit() {
    //console.log('app.component', 'ngAfterViewInit', this.userProfile);
  }

  private async dismissAllOpenModalsForNavigation(): Promise<void> {
    if (this.isDismissingModalsForNavigation) {
      return;
    }

    this.isDismissingModalsForNavigation = true;
    try {
      const topModal = await this.modalController.getTop();

      if (!topModal) {
        return;
      }

      // Override canDismiss so navigation cleanup is not blocked by modal config.
      (topModal as any).canDismiss = true;
      await topModal.dismiss(undefined, 'navigation');
    } catch (error) {
      console.warn(
        'AppComponent: failed to dismiss modal(s) on navigation',
        error,
      );
    } finally {
      this.isDismissingModalsForNavigation = false;
    }
  }

  /**
   * Drills down to the deepest activated route
   * so we can read data (like excludeIdle).
   */
  private getDeepestRouteData(): Data | undefined {
    let current = this.route.root;
    while (current.firstChild) {
      current = current.firstChild;
    }
    return current.snapshot.data;
  }

}
